import { DataTable } from "../../components/DataTable.tsx";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import MemberShipCard from "../../components/MemberShipCard.tsx";
import { useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { communityService, groupService } from "../../services";
import { Skeleton } from "../../components/ui/skeleton";
import LoadingImage from "../../components/LoadingImage.js";
import { createItemStore } from "../../stores/createItemStore";
import useUserStore2 from "../../stores/userStore2";

const columns = [
  // {
  //   accessorKey: "communityId",
  //   header: "Community ID",
  //   cell: ({ row }) => (
  //     <span>
  //       <ShortenedText text={row.getValue("communityId")} />
  //     </span>
  //   ),
  // },
  {
    accessorKey: "communityName",
    header: "Community Name",
    cell: ({ row }) => <span>{row.getValue("communityName")}</span>,
  },
  {
    accessorKey: "totalGroups",
    header: "Total Groups",
    cell: ({ row }) => <span>{row.getValue("totalGroups")}</span>,
  },
  {
    accessorKey: "totalMembers",
    header: "Total Members",
    cell: ({ row }) => <span>{row.getValue("totalMembers")}</span>,
  },
];

// ========================================================
// Step 1: Zustand store instantiation
// ========================================================

const communityDataMap = (item) => ({
  communityId: item._id, // Mapping _id to communityId
  communityName: item.name, // Mapping name to communityName
  adminId:
    item.admins.length > 0
      ? item.admins.map((admin) => admin.profile?._id || "Unknown").join(", ")
      : "N/A", // Extracting profile ID, handling missing profile field
  status: item.status === "A" ? "Active" : "Dormant", // Converting status
  adminProfile:
    item.admins.length > 0
      ? item.admins.map((admin) => admin.profile?.name || "Unknown").join(", ")
      : "N/A", // Extracting profile NAME, handling missing profile field
  address: `${item.address_line1}${
    item.address_line2 ? `, ${item.address_line2}` : ""
  }`, // Handling null address_line2
  city: item.city, // Keeping city as is
});

let storeName = "communities";
const useCommunities = createItemStore(
  storeName,
  (community) => community.communityId,
  communityService.getCommunity,
  communityDataMap
);

const groupDataMap = (item) => ({
  groupId: item._id,
  groupName: item.name,
  communityName: item.community?.name || "N/A",
  communityId: item.community?._id || "N/A",
  status:
    item?.status === "A"
      ? "Active"
      : item?.status === "D"
      ? "Deactivated"
      : item?.status,
  groupLeader:
    item.leaders && item.leaders.length > 0
      ? item.leaders
          .map((leader) => leader.profile?.name)
          .filter(Boolean) // remove any undefined/null names
          .join(", ")
      : "N/A",
  totalMembers: item.total,
  dateCreated: item.create_date
    ? new Date(item.create_date).toLocaleDateString()
    : "N/A",
});

storeName = "groups";
const useGroups = createItemStore(
  storeName,
  (group) => group.groupId,
  groupService.getGroups,
  groupDataMap
);
// ========================================================

export default function MemberCommunity() {
  const navigate = useNavigate();
  const { user } = useUserStore2((state) => state);
  // console.log(`user:`, user);

  const actions = (row) => [
    {
      label: "View Details",
      icon: <FaEye />,
      onClick: () => navigate(`/view-communities/${row.communityId}`),
      variant: "dropPlain",
    },
  ];

  // ========================================================
  // Step 2: Zustand store and page hydration
  // ========================================================

  // Memberships based on current profile's membership
  const data = user?.currentProfile?.memberships || [];
  // No fetching or loading is needed
  const showLoading = false;

  // Communities
  const {
    isLoading: isLoadingCommunities,
    fetchItems: fetchCommunities,
    getSortedFiltered: getSortedFilteredCommunities,
  } = useCommunities((state) => state);
  const communitiesData = getSortedFilteredCommunities();
  const showCommunitiesLoading =
    communitiesData.length === 0 && isLoadingCommunities;
  // console.log(`${storeName}:`, data);
  useEffect(() => {
    fetchCommunities();
  }, []);

  // Groups
  const {
    isLoading: isLoadingGroups,
    fetchItems: fetchGroups,
    getSortedFiltered: getSortedFilteredGroups,
  } = useGroups((state) => state);
  const groupsData = getSortedFilteredGroups();
  const showGroupsLoading = groupsData.length === 0 && isLoadingGroups;
  // console.log(`${storeName}:`, data);
  useEffect(() => {
    fetchGroups();
  }, []);

  const showCommunityTableLoading = showCommunitiesLoading || showGroupsLoading;

  const tableData = communitiesData.map((community) => {
    // Find all groups belonging to this community
    const groupsForCommunity = groupsData.filter(
      (group) => group.communityId === community.communityId
    );
    // Count total groups
    const totalGroups = groupsForCommunity.length;
    // Sum total members across all groups
    const totalMembers = groupsForCommunity.reduce(
      (sum, group) => sum + (group.totalMembers || 0),
      0
    );
    return {
      communityId: community.communityId,
      communityName: community.communityName,
      totalGroups,
      totalMembers,
    };
  });

  // console.log(`user?.currentProfile?.memberships:`, user?.currentProfile?.memberships)

  // ========================================================

  return (
    <div className="flex flex-col md:flex-row min-h-screen ">
      <div className="flex-1 flex flex-col">
        <div className="flex-1 sm:p-">
          {/* <div
            id="whitedivbox"
            className="bg-white shadow container rounded-lg md:max-w-[calc(100vw-375px)] p-4 sm:p-6 text-sm md:mt-0 relative overflow-hidden w-full mb-4"
          >
           
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2">
              <div className="text-base sm:text-lg font-semibold text-[#111827]">
                Community Memberships
              </div>
            </div>
            <hr />

           
            <div className="flex items-center w-full overflow-x-auto md:overflow-visible">
             
              <button
                onClick={scrollLeft}
                className="hidden md:inline-flex bg-white border border-gray-300 p-2 mr-2 rounded-full hover:bg-gray-100"
              >
                <ChevronLeft className="w-5 h-5 text-gray-700" />
              </button>

              
              <div className="overflow-x-auto w-full">
                <div
                  ref={scrollRef}
                  className="flex gap-4 sm:gap-6 overflow-x-auto no-scrollbar scroll-smooth whitespace-nowrap w-full px-1"
                >
                  
                  {showLoading
                    ? [...Array(3)].map((_, index) => (
                      <Skeleton
                        key={index}
                        className="min-w-[16rem] w-64 h-40 rounded-lg"
                      />
                    ))
                    // : Array.isArray(getMembershipDetails.data) && getMembershipDetails.data.length === 0 ? (
                    : data.length === 0 ? (
                        <div
                          className="min-w-[16rem] w-64 h-40 rounded-lg flex items-center justify-center border-2 border-dotted border-gray-300 bg-gray-50 text-gray-400"
                          style={{ borderStyle: "dotted" }}
                        >
                          No membership found
                        </div>
                      )
                      // : getMembershipDetails.data?.map((membership) => (
                      : user?.currentProfile?.memberships?.map((membership) => (
                        <MemberShipCard
                          key={membership.membershipId}
                          name={membership.communityName}
                          groupName={membership.groupName || ""}
                          variant="teal"
                          communityId={membership.communityId}
                        />
                      ))}
                </div>
              </div>

             
              <button
                onClick={scrollRight}
                className="hidden md:inline-flex bg-white border border-gray-300 p-2 ml-2 rounded-full hover:bg-gray-100"
              >
                <ChevronRight className="w-5 h-5 text-gray-700" />
              </button>
            </div>
          </div> */}
        </div>

        <div className="flex-1 p-4 md:pt-0 mt-0  sm:p-8 ">
          <div className="bg-white shadow rounded-lg md:max-w-[calc(100vw-375px)] p-4 sm:p-7 text-sm mt-0 relative">
            <div className="flex flex-col sm:flex-row justify-between mb-4">
              <div className="text-base sm:text-lg font-semibold text-[#111827]">
                Communities List
              </div>
            </div>
            <hr />
            <div className="overflow-x-auto w-full  max-w-screen-lg">
              {showCommunityTableLoading ? (
                // {!getCommunity?.data?.length > 0 ? (
                <LoadingImage />
              ) : tableData?.length > 0 ? (
                <DataTable
                  columns={columns}
                  data={tableData}
                  actions={actions}
                  disableCheckboxes={true}
                />
              ) : (
                <div className="text-center text-gray-500 py-6">
                  No communities found.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
